import React from 'react';

const InsuranceSection = ({ insuranceData }) => (
  <div className="insurance-section">
    <h2>Insurance Details</h2>
    {insuranceData.map((ins, idx) => (
      <div key={idx} className="insurance-card">
        <p><strong>Insurance Name:</strong> {ins.insuranceName}</p>
        <p><strong>Coverage:</strong> {ins.coverageName}</p>
        <p><strong>Code:</strong> {ins.insCode}</p>
      </div>
    ))}
  </div>
);

export default InsuranceSection;